var React = require('react');

function HomeIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.5541 9.85879C17.5541 3.97548 14.8837 0.714844 10.2457 0.714844C5.53734 0.714844 2.44531 4.18813 2.44531 9.85879C2.44531 15.7421 5.53734 19.2863 10.3862 19.2863C13.5485 19.2863 16.0081 17.656 17.4136 14.4662L13.5485 13.0485C12.9161 14.6789 11.7917 15.5295 10.597 15.5295C8.98074 15.5295 8.06719 14.0409 8.06719 11.2056H17.5541C17.5541 10.6385 17.5541 10.2132 17.5541 9.85879ZM12.2125 7.73386H7.92578V7.52121C7.92578 5.46559 8.76906 4.40234 10.1043 4.40234C11.4395 4.40234 12.2125 5.46559 12.2125 7.45033V7.73386Z","fill":"#E20000"}));
}

HomeIcon.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = HomeIcon;

HomeIcon.default = HomeIcon;
